<template>
  <div class="main-log">
    <main>
      <header>
        <h3>审计日志</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="opname">
            <a-input-search placeholder="操作人/内容" style="width: 200px;" allow-clear :loading="btnLoad"
                            v-model.trim="pagination.opname" @input="searchTextChange" />
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                style="width: 180px;"
                @change="searchChange"
                placeholder="选择部门"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item prop="logType">
            <a-select
                show-search
                :filter-option="filterOption"
                v-model="pagination.logType"
                placeholder="类型"
                style="width: 180px;"
                :loading="btnLoad"
                allowClear
                @change="searchChange"
            >
              <a-select-option  v-for="(item,index) in stateList" :value="index">{{item}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="time">
            <a-range-picker :value="pagination.time" v-model="pagination.time"
                            :placeholder="['操作时间: 开始', '操作时间: 结束']"  valueFormat="YYYY-MM-DD" style="width: 300px;" @change="searchChange" />
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns"  bordered :data-source="tableData" :loading="tableLoad" :pagination="queryCondition"
        @change="handleTableChange" :scroll="{ y: 560 }">
        <template slot="logType" slot-scope="text">
          <span>
            {{ stateList[text]  }}
          </span>
        </template>
        <span slot="num" slot-scope="text, record, index">
          {{  (Page.current - 1) * Page.pageSize + parseInt(index) + 1  }}
        </span>
        <span slot="action" slot-scope="record"  class="table-action-box">

            <a-tooltip  content="" v-if="$IA('system:jobLog:findPage')" title="查看详情" placement="top" effect="light">
              <i class="table-view" v-if="record.logType == 4" @click="detail(record)" ></i>
            </a-tooltip>

        </span>
      </a-table>
    </main>


    <!-- 查看详情 -->
    <a-modal centered title="查看详情"  width="750px" :visible="modalVisible" :confirm-loading="btnLoad"
      @cancel="modalVisible = false"     :maskClosable="false">
      <div class="modifyContent">
        <!-- 修改前 -->
        <div class="front">
          <p style="font-weight: bold">修改前</p>
            <table >
              <tr v-for="(item,index) in this.detailsData" :key="index">
                <td>{{item.propertyChineseName}}:</td>
                <td>
                  <a-tooltip>
                    <template slot="title">
                       <span :style="item.oldValue ? 'color:#ee5375;': ''">
                        {{item.oldValue? item.oldValue : item.value}}
                      </span>
                    </template>
                      <span :style="item.oldValue ? 'color:#ee5375;': ''">
                      {{item.oldValue? item.oldValue : item.value}}
                    </span>
                  </a-tooltip>

                </td>
              </tr>
            </table>
        </div>
        <!-- 修改后 -->
        <div class="after">
          <p style="font-weight: bold">修改后</p>
          <table >
            <tr v-for="(item,index) in this.detailsData" :key="index">
              <td>{{item.propertyChineseName}}:</td>
              <td>
                <a-tooltip>
                  <template slot="title">
                    <span :style="item.newValue ? 'color:#54bd68;': ''">
                      {{item.newValue? item.newValue : item.value}}
                    </span>
                  </template>
                  <span :style="item.newValue ? 'color:#54bd68;': ''">
                    {{item.newValue? item.newValue : item.value}}
                  </span>
                </a-tooltip>


              </td>
            </tr>
          </table>
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="modalVisible = false">
          关闭
        </a-button>

      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      pagination: {
        opname: "",
        time:[],
        logType:undefined,
        orgId:undefined,
        pageSize: 10,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout:"inline",
      queryCondition:{},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '操作人',
          dataIndex: "opname",
          key: "opname",
        },
        {
          title: '部门',
          dataIndex: 'orgName',
          key: 'orgName',
          ellipsis: true,
        },
        {
          title: "类型",
          dataIndex: "logType",
          key: "logType",
          ellipsis: true,
          scopedSlots: { customRender: "logType" },
        },
        {
          title: "内容",
          dataIndex: "content",
          key: "content",
          ellipsis: true
        },
        {
          title: "操作时间",
          dataIndex: "createTime",
          key: "createTime",
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 70,
        },
      ],
      tableData: [],
      addFormRules: {
        name: [{ required: true, message: "计算机名称不能为空" }],
        type: [{ required: true, message: "类型不能为空" }],
      },
      detailsData:[],
      modalVisible:false,
      // 操作类型
      stateList:{},
      // 部门
      treeData:[]
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 开启搜索
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 部门
    allorgList(){
      this.axios
          .post("/org/findOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 重置搜索
    resetSearch(){
      this.$refs.searchBar.resetFields()
      this.pagination.current  = 1
      this.searchChange()
    },
    // 查看详情
    detail(data){
      this.modalVisible = true
      this.detailsData = []
      this.axios
          .get("/syslog/getById/" + data.id )
          .then((res) => {
            console.log(res)
            if (res.code === 200) {
              let allData = []
              JSON.parse( res.data.params ).forEach((v)=>{
                if ( res.data.sysLogAudit){
                  JSON.parse( res.data.sysLogAudit.recContent ).forEach((b)=>{
                    if (v.propertyName == b.propertyName){
                      v.newValue = b.newValue
                      v.oldValue = b.oldValue
                    }
                  })
                }

                allData.push(v)
              })
              this.detailsData = allData
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 打开模态框
    handleOpen(title) {
      this.modalTitle = title;
      this.modalVisible = true;
      switch (title) {
        case "添加":
          break;
        case "修改":
          break;
        case "删除":
          break;
      }
    },
    // 确认模态框
    handleOk() {
      console.log("OK");
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.queryCondition.time = this.queryCondition.time ? this.queryCondition.time.join(',') : ''
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo = pagination.current
      this.queryCondition.current = pagination.current
      this.queryCondition.pageSize = pagination.pageSize
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
        .post("/syslog/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
            this.tableData = res.data.records;
            this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount() {
    this.searchChange()
    this.allorgList()

    // 操作类型
    this.axios
        .post("/syslog/getSysLogSelector")
        .then((res) => {
          if (res.code === 200) {
            this.stateList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
  }
};
</script>

<style lang="scss" scoped>
.main-log {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }


    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

    .ant-tag {
      border-radius: 16px;
    }
  }


}
.modifyContent{
  display: flex;
  width: 100%;
  justify-content: space-between;
  .front,.after{
    table{
     width: 340px;
     table, th, td {
       border: 1px solid #f3f3f3;
       padding:10px;
       border-radius: 4px;
     }

     tr{
       width: 100%;

       td:nth-child(1){
         width: 125px;
         color: #97a6b7;
         //font-weight: 600;
         font-size: 14px;
       }
       td:nth-child(2){
         color:#212121;
         //font-weight: 600;
         font-size: 15px;
        span{
          width: 210px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
       }
     }
   }
  }
}

</style>
